import PropTypes from 'prop-types';

import { useTheme } from '@zenbusiness/zui/styles';

import SubscriptionResultStep from '../SubscriptionCancel/components/SubscriptionResultStep';

/** Shared-asset paths (resolved via ZUI SharedAsset). Align with Cancel flow use of SharedAsset. */
const SUCCESS_ILLUSTRATION_SRC = '/illustration/subscription-updated.svg';
const ERROR_ILLUSTRATION_SRC = '/illustration/contact-cs.svg';

const ILLUSTRATION_SIZE = 220;
const outlinedButtonSx = { borderRadius: '12px', height: 56 };

export default function RestartResultStep({ success, onReturnDashboard, onReturnSubscriptions, onContactUs }) {
  const theme = useTheme();
  const primaryButtonSx = {
    borderRadius: '12px',
    height: 56,
    backgroundColor: theme.palette.primary.main,
    '&:hover': { backgroundColor: theme.palette.primary.dark },
  };

  return (
    <SubscriptionResultStep
      success={success}
      successIllustrationSrc={SUCCESS_ILLUSTRATION_SRC}
      errorIllustrationSrc={ERROR_ILLUSTRATION_SRC}
      successHeadingMessageId="dashboard.subscriptionRestart.result.success.heading"
      successBodyMessageId="dashboard.subscriptionRestart.result.success.body"
      errorHeadingMessageId="dashboard.subscriptionRestart.result.error.heading"
      errorBodyMessageId="dashboard.subscriptionRestart.result.error.body"
      successButtons={[
        {
          labelMessageId: 'dashboard.subscriptionRestart.result.success.returnToDashboard',
          onClick: onReturnDashboard,
          variant: 'outlined',
          sx: outlinedButtonSx,
        },
        {
          labelMessageId: 'dashboard.subscriptionRestart.result.success.returnToSubscriptions',
          onClick: onReturnSubscriptions,
          variant: 'contained',
          sx: primaryButtonSx,
        },
      ]}
      errorButtons={[
        {
          labelMessageId: 'dashboard.subscriptionRestart.result.error.returnToSubscriptions',
          onClick: onReturnSubscriptions,
          variant: 'outlined',
          sx: outlinedButtonSx,
        },
        {
          labelMessageId: 'dashboard.subscriptionRestart.result.error.contactUs',
          onClick: onContactUs,
          variant: 'contained',
          sx: primaryButtonSx,
        },
      ]}
      illustrationSize={ILLUSTRATION_SIZE}
      illustrationSx={{ width: { xs: 160, sm: 220 } }}
    />
  );
}

RestartResultStep.propTypes = {
  success: PropTypes.bool.isRequired,
  onReturnDashboard: PropTypes.func.isRequired,
  onReturnSubscriptions: PropTypes.func.isRequired,
  onContactUs: PropTypes.func.isRequired,
};
